import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useTheme, Button, TextField, Checkbox, Snackbar, Alert, FormControl, Select, MenuItem } from '@mui/material';
import Pagination from "react-js-pagination";
import axios from 'axios'
import { useNavigate } from 'react-router-dom';
import { TbLoader } from 'react-icons/tb';
import mainPath from '../../../utils/path';
import { MdOutlineRefresh } from "react-icons/md";
import { AiOutlineDoubleLeft, AiOutlineDoubleRight, AiOutlineLeft, AiOutlineRight } from "react-icons/ai";

const useStyles = makeStyles((theme)=>({
  main: {
    
  },
  box: {
    margin:'0 auto',
    maxWidth:'1800px',
    padding:'0 20px',
  },
  h1SearchDiv:{
    padding:'40px 0px 0 0',
    display:'flex',
    flexDirection:'column',
  },
  itmeQtyConfigBlockH1:{
    fontWeight:'700',
    fontSize:'22px',
    display: 'flex'
  },
  datagridBox: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  datagridTop: {
    display: 'flex',
    borderTop: '1px solid #D3D3D3',
    borderBottom: '1px solid #D3D3D3',
    [theme.breakpoints.down(1025)]: {
      fontSize:'11px'
    }
  },
  datagridTopItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #D3D3D3',
    borderTop: 'none',
    borderBottom: 'none',

    [theme.breakpoints.down(1025)]: {
      display:'none',            
    }
  },
  mobileDatagridTopItem:{
    display:'none',

    [theme.breakpoints.down(1025)]: {
      display:'block',   
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '1px solid #D3D3D3',
      borderTop: 'none',
      borderBottom: 'none',
    }
  },
  contBox: {
    display: 'flex',
    borderBottom: '1px solid #D3D3D3',
    [theme.breakpoints.down(1025)]: {
      fontSize:'11px'
    }
  },
  contBoxItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #D3D3D3',
    borderTop: 'none',
    borderBottom: 'none',
    wordBreak:'break-all',

    [theme.breakpoints.down(1025)]: {
      display:'none',            
    }
  },
  mobileContBoxItem:{
    display:'none',

    [theme.breakpoints.down(1025)]: {
      display:'block', 
      borderTop: 'none',
      borderBottom: 'none',
      wordBreak:'break-all',
      textAlign:'center',
      width:'32%', 
      alignItems: 'center',
      justifyContent: 'start',  
      display: 'flex',        
    }
  },
  checkBoxItm: {
    width: '7%',
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center',
  },
  textMiddle: {
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'center', 
    alignItems: 'center'
  },
  imageText: {
    display: 'flex',
    alignItems: 'center'
  },
  innerClass: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '15px',
    listStyle: 'none',
    padding: 0,
  },
  itemClass: {
      minWidth: '30px',
      border: '1px solid #e2e2e2',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '1rem',
  },
  itemClassFirst: {
      borderRadius: '15px 0 0 15px',
  },
  itemClassLast: {
      borderRadius: '0 15px 15px 0',
  },
  linkClass: {
      textDecoration: 'none',
      color: '#383A3F',
      fontSize: '1rem',
  },
  activeClass: {
      backgroundColor: '#383A3F'
  },
  activeLinkClass: {
      color: 'white',
  },
  btnDiv:{
    display:'flex',
    justifyContent:'end',
    padding:'0 0 20px 0'
  },
  formDiv:{
    display:'flex',
    marginRight:'10px'
  },
  bottomDiv:{
    padding:'30px 0',
    display:'flex',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      alignItems:'flex-start',
    }
  },
  formDiv:{
    display:'flex',
    marginRight:'10px',
    [theme.breakpoints.down(1025)]: {
      margin:'10px 0  0 0',
    }
  },
  formBox:{

  },
  RightDiv:{
    margin:'0 0 0 20px',
    display:'flex',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      margin:'0',
    }
  },
  RightDivBtn:{
    [theme.breakpoints.down(1025)]: {
      paddingTop:'10px',
    }
  },
  load:{
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
  },
  loadingIcon:{
    color:'#007235',
    fontSize:'50px',
    animation:'$loadSpin 5s infinite'
  },
  "@keyframes loadSpin":{
    from: { transform:'rotate(0deg)' },
    to: { transform:'rotate(1turn)' }
  },
  navibox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems:'center'
  },
  naviArrow: {
    marginTop: 13,
    cursor: 'pointer',
    border: '1px solid gray',
    padding: 5
  }

}));

const ItmeQtyConfig = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  let navigate = useNavigate();
  const checkBox = true
  const [page, setPage] = useState(1);
  const [pasings, setPasings] = useState(0);
  const [checks, setChecks] = useState([])
  const [allChecked, setAllChecked] = useState(false)
  const [cateList, setCateList] = useState([])
  
  const [errSnack, setErrSnack] = useState(false);
  const [succSnack, setSuccSnack] = useState(false);

  const [searchType1, setSearchType1] = useState(0);
  const [searchType2, setSearchType2] = useState(0);
  const [keyword, setKeyword] = useState('');
  const [search, setSearch] = useState(false);
  const [loading, setLoading] = useState(false)

  const row = [
    {name: '상품코드', width: 350},
    {name: '상품명', width: 600},
    {name: '창고재고', width: 200},
    {name: '주문대기', width: 200},
    {name: '가재고', width: 200},
    {name: '관리', width: 200},
  ];

  const mobileRow = [
    {name: '상품명', width: 600},
    {name: '주문대기', width: 200},
    {name: '가재고', width: 200},
    {name: '관리', width: 200},
  ];
  
  const [data, setData] = useState([])

  useEffect(() => {
    window.scrollTo(0, 0);

    return () => {
      setData([])
      setChecks([])
      setAllChecked(false)
      setPage(1)
      setPasings(0)
      setCateList([])
      setSearch(false)
      setSearchType1(0)
      setSearchType2(0)
      setKeyword('')
    }
  }, [])

  const getStockItems = async() => {
    try {
      setLoading(true)
      const res = await axios.get(`/api/adm/itemStock/${page}/`)

      if(res.data.success === false) {
        setErrSnack(true)
        setLoading(false)
        return ;
      }

      setData(res.data.result.reduce((result, item) => ([
        ...result, 
        [
        {id: item['iq_id'], data: item['it_id'], type: 'textMiddleId'}, //
        {id: item['iq_id'], data: item['it_name'], type: 'imageText', img: item['it_img1']}, //
        {id: item['iq_id'], data: item['it_stock_qty'], type: 'textMiddleStock1'},
        {id: item['iq_id'], data: item['order_qty'], type: 'textMiddleOrder'}, //
        {id: item['iq_id'], data: item['it_stock_qty'] - item['order_qty'], type: 'textMiddleStock2'}, //
        {id: item['it_id'], data: ['수정'], type: 'button'}, //
        ]
      ]), []))
      setPasings(res.data.itemCount)
      setCateList(res.data.cateList)
      setLoading(false)
      
      
  
    } catch (e) {
      setErrSnack(true)
      setLoading(false)
      console.log(e)
    }
  }

  const searchItem = async() => {
    
    setSearch(true)

    try {
      setLoading(true)
      const res = await axios.post('/api/adm/itemStockSearch/', {page: page, search_type1: searchType1, search_type2: searchType2, keyword: keyword} )

      if(res.data.success === false) {
        setErrSnack(true)
        setLoading(false)
        return;
      }

      setData(res.data.result.reduce((result, item) => ([
        ...result, 
        [
        {id: item['iq_id'], data: item['it_id'], type: 'textMiddleId'}, //
        {id: item['iq_id'], data: item['it_name'], type: 'imageText', img: item['it_img1']}, //
        {id: item['iq_id'], data: item['it_stock_qty'], type: 'textMiddleStock1'},
        {id: item['iq_id'], data: item['order_qty'], type: 'textMiddleOrder'}, //
        {id: item['iq_id'], data: item['it_stock_qty'] - item['order_qty'], type: 'textMiddleStock2'}, //
        {id: item['it_id'], data: ['수정'], type: 'button'}, //
        ]
      ]), []))

      setPasings(res.data.itemCount)
      setCateList(res.data.cateList)

      setChecks([])
      setAllChecked(false)
      setLoading(false)
      
  
    } catch (e) {
      setErrSnack(true)
      setLoading(false)
      console.log(e)
    }

    if (keyword === '' && searchType1 === 0){
      setSearch(false)
    }

  }

  useEffect(() => {

    if(search) {
      searchItem()
    } else{
      getStockItems()
    }
    setChecks([])
    setAllChecked(false)
    
  }, [page])


  useEffect(() => {
    // 전체선택 관련 로직
    let allCheckList = []

    if(allChecked) {
      data.forEach(item => allCheckList.push(item[0].data))
      setChecks(allCheckList)
    } else {
      setChecks(allCheckList)
    }
    
  }, [allChecked])


  const handlePageChange = (page) => {
    setPage(page);
  };


  const editSelItems = async() => {
    let itList = []
    checks.forEach((arrItem) => {
      data.forEach((dataItem) => {
        if(dataItem[0].data === arrItem){
          itList.push({
            it_id: dataItem[0].data, 
            it_stock_qty: dataItem[5].data, 
            it_use: dataItem[6].data, 
            it_soldout: dataItem[7].data
          })
        } 
      })
    })

    try {
      const res = await axios.post('/api/adm/itemStockSelectEdit/', {it_list: itList} )

      if(res.data.success === false){
        setErrSnack(true)
        console.log('실패')
        return ;
      }
      setSuccSnack(true)
      setChecks([])
      setAllChecked(false)
      getStockItems()

  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }





  const snackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setErrSnack(false);
    setSuccSnack(false)
  };

  return (
    <div className={classes.itmeQtyConfigBlock}>
      <div className={classes.box}>
        <div className={classes.h1SearchDiv}>
          <h1 className={classes.itmeQtyConfigBlockH1}>
            상품재고관리
            <div
                onClick={() => {
                  setData([])
                  setPage(1)
                  setSearch(false)
                  setSearchType1(0)
                  setSearchType2(0)
                  setKeyword('')
                  getStockItems()
                }}
              style={{cursor:'pointer'}}
            >
              <MdOutlineRefresh/>
            </div>
          </h1>
          <div className={classes.bottomDiv}>
            <div className={classes.formDiv}>
              <FormControl 
                size="small"
                className={ classes.formBox}
              >
                <Select
                  value={searchType1}
                  onChange={(e) => setSearchType1(e.target.value)}
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  <MenuItem value={0}>전체분류</MenuItem>
                  {cateList.length > 0 && cateList.map((item) => (
                      <MenuItem key={item['ca_id']} value={item['ca_id']}>{`${item['ca_name']}(${item['ca_id']})`}</MenuItem>
                  ))}
                    
                </Select>
              </FormControl>
            </div>
            <div className={classes.formDiv}>
              <FormControl size="small">
                <Select
                  value={searchType2}
                  onChange={(e) => setSearchType2(e.target.value)}
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  <MenuItem value={0}>상품명</MenuItem>
                  <MenuItem value={1}>상품코드</MenuItem>
                </Select>
              </FormControl>
              </div>
              <div className={ classes.RightDiv}>
                <TextField 
                  label="검색어를 입력해주세요." 
                  variant="standard" 
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  onKeyDown={(e) => {
                    if(e.key === 'Enter') {
                      setPage(1)
                      searchItem()
                    }
                  }}
                />          
              <div className={classes.RightDivBtn}>
                <Button 
                  variant="outlined"
                  onClick={() => {
                    setPage(1)
                    searchItem()
                  }}
                >
                  검색
                </Button>
              </div>
              </div>
          </div>
        </div>
        <div className={classes.btnDiv}>
          <Button variant="outlined" onClick={() => checks.length > 0 && editSelItems()}>
            선택수정
          </Button>
        </div>
        <div className={classes.datagridBox}>
          <div className={classes.datagridTop}>
            {checkBox && (
                <div className={classes.checkBoxMain}>
                  <Checkbox 
                    checked={allChecked}
                    onChange={e => setAllChecked(e.target.checked)}
                  />
                </div>
            )}
            {row.map((item, index) => (
                      <div key={index} className={classes.datagridTopItem} style={{width: item.width}}>
                        {item.name}
                      </div>
            ))}

            {mobileRow.map((item, index) => (
                      <div key={index} className={classes.mobileDatagridTopItem} style={{width: item.width}}>
                        {item.name}
                      </div>
            ))}
          </div>
  
          {loading ? (
            <div className={classes.load}>
              <TbLoader className={classes.loadingIcon}/>
            </div>
          ) :
          data.length > 0 && data.map((dataItem, dataIndex) => {
            return(
                    <div 
                      key={dataIndex} 
                      className={classes.contBox}
                      style={{
                        backgroundColor: dataIndex % 2 == 0 && '#F2F2F2'
                      }}
                    >
  
                        {checkBox && (
                          <div className={classes.checkBoxMain}>
                            <Checkbox
                              checked={checks.includes(dataItem[0].data)}
                              onChange={() => !checks.includes(dataItem[0].data) ?
                                              setChecks([...checks, dataItem[0].data]) : 
                                              setChecks([...checks.filter((item) => item !==  dataItem[0].data)])
                                        }
                            />
                          </div>
                        )}
  
                        {dataItem.map((item, index) => {
                          return(
                                <div key={index} 
                                  className={classes.contBoxItem}
                                  style={{width: row[index].width}}
                                >
                                  {item.type === 'textMiddleId' && (
                                    <h3 className={classes.textMiddle}>{item.data}</h3>
                                  )}
                                  {item.type === 'imageText' && (
                                    <div className={classes.imageText}>
                                      <img
                                        style={{width: 50, height: 50, marginRight: 5}}
                                        src={`${mainPath}/media/data/item/${item.img}`} 
                                      />
                                      <h3>{item.data}</h3>
                                    </div>
                                  )}
                                  {item.type === 'textMiddleStock1' && (
                                    <h3 className={classes.textMiddle}>{item.data}</h3>
                                  )}
                                  {item.type === 'textMiddleOrder' && (
                                    <h3 className={classes.textMiddle}>{item.data}</h3>
                                  )}
                                  {item.type === 'textMiddleStock2' && (
                                    <h3 className={classes.textMiddle}>{item.data}</h3>
                                  )}
                                  {item.type === 'numberfield' && (
                                    <TextField
                                      hiddenLabel
                                      id="filled-hidden-label-small"
                                      value={item.data}
                                      variant="filled"
                                      size="small"
                                      fullWidth
                                      type='number'
                                      onChange={(e) => {
                                          let dataList = [...data]
                                          let arrayItm = {...dataList[dataIndex][index], data: parseInt(e.target.value)}
                                          dataList[dataIndex][index] = arrayItm
                                          setData(dataList)}
                                        }
                                    />
                                  )}
                                  {item.type === 'button' && 
                                    (
                                      <div style={{width: '100%', height: '100%', display:'flex', justifyContent:'center', alignItems:'center'}}>
                                        {item.data.map((btnItm, btnIdx) => (
                                        <Button 
                                          key={btnIdx} 
                                          variant="text"
                                          onClick={() => {
                                            navigate("/DashboardMain/itemEdit", {
                                              state: { it_id: item.id }
                                            });
                                          }}
                                        >
                                          {btnItm}
                                        </Button>))}
                                      </div>
                                    )
                                  }
                                  {item.type === 'checkbox' && (
                                    <div className={classes.checkBoxItm}>
                                      <Checkbox
                                        checked={data[dataIndex][index].data === 0 ? false : true }
                                        onChange={() => {
                                            let dataList = [...data]
                                            let arrayItm = data[dataIndex][index].data === 0 ? {...dataList[dataIndex][index], data: 1} : {...dataList[dataIndex][index], data: 0} 
                                            dataList[dataIndex][index] = arrayItm
                                            setData(dataList)
                                        }}
                                      />
                                    </div>
                                  )}
  
                                </div>
                        )})}

                        {dataItem.map((item, index) => {
                          if (index !== 1 && index !== 3 && index !== 4 && index !== 8) return;
                          return(
                                <div key={index} 
                                  className={classes.mobileContBoxItem}
                                  style={{width: row[index].width}}
                                >
                                  {item.type === 'textMiddleId' && (
                                    <h3 className={classes.textMiddle}>{item.data}</h3>
                                  )}
                                  {item.type === 'imageText' && (
                                    <div className={classes.imageText}>
                                      <img
                                        style={{width: 50, height: 50, marginRight: 5}}
                                        src={`${mainPath}/media/data/item/${item.img}`} 
                                      />
                                      <h3>{item.data}</h3>
                                    </div>
                                  )}
                                  {item.type === 'textMiddleStock1' && (
                                    <h3 className={classes.textMiddle}>{item.data}</h3>
                                  )}
                                  {item.type === 'textMiddleOrder' && (
                                    <h3 className={classes.textMiddle}>{item.data}</h3>
                                  )}
                                  {item.type === 'textMiddleStock2' && (
                                    <h3 className={classes.textMiddle}>{item.data}</h3>
                                  )}
                                  {item.type === 'numberfield' && (
                                    <TextField
                                      hiddenLabel
                                      id="filled-hidden-label-small"
                                      value={item.data}
                                      variant="filled"
                                      size="small"
                                      fullWidth
                                      type='number'
                                      onChange={(e) => {
                                          let dataList = [...data]
                                          let arrayItm = {...dataList[dataIndex][index], data: parseInt(e.target.value)}
                                          dataList[dataIndex][index] = arrayItm
                                          setData(dataList)}
                                        }
                                    />
                                  )}
                                  {item.type === 'button' && 
                                    (
                                      <div style={{width: '100%', height: '100%', display:'flex', justifyContent:'center', alignItems:'center'}}>
                                        {item.data.map((btnItm, btnIdx) => (
                                        <Button 
                                          key={btnIdx} 
                                          variant="text"
                                          onClick={() => {
                                            navigate("/DashboardMain/itemEdit", {
                                              state: { it_id: item.id }
                                            });
                                          }}
                                        >
                                          {btnItm}
                                        </Button>
                                        ))}
                                      </div>
                                    )
                                  }
                                  {item.type === 'checkbox' && (
                                    <div className={classes.checkBoxItm}>
                                      <Checkbox
                                        checked={data[dataIndex][index].data === 0 ? false : true }
                                        onChange={() => {
                                            let dataList = [...data]
                                            let arrayItm = data[dataIndex][index].data === 0 ? {...dataList[dataIndex][index], data: 1} : {...dataList[dataIndex][index], data: 0} 
                                            dataList[dataIndex][index] = arrayItm
                                            setData(dataList)
                                        }}
                                      />
                                    </div>
                                  )}
  
                                </div>
                        )})}
                    </div>
          )})}
  
        </div>
  
        <div className={classes.navibox}>
          <AiOutlineDoubleLeft 
            onClick={() => setPage(1)}
            className={classes.naviArrow}
            size="24"
          />
          <AiOutlineLeft 
            onClick={() => setPage(page-5 <= 0 ? 1 : page-5)}
            className={classes.naviArrow}
            size="24"
          />
          <Pagination
              activePage={page}
              itemsCountPerPage={15}
              totalItemsCount={pasings}
              pageRangeDisplayed={5}
              prevPageText={"‹"}
              nextPageText={"›"}
              onChange={handlePageChange}
              className={classes.navi}
              innerClass={classes.innerClass}    //안에?
              itemClass={classes.itemClass}      //아이템들?
              itemClassFirst={classes.itemClassFirst}    //first?
              itemClassLast={classes.itemClassLast}     // last
              linkClass={classes.linkClass}        // 아이템 링크
              activeClass={classes.activeClass}        // 현재페이지
              activeLinkClass={classes.activeLinkClass}     // 현제페이지 링크
              hideDisabled
              hideNavigation
              hideFirstLastPages
          />
          <AiOutlineRight 
            onClick={() => setPage(page+5 > Math.ceil(pasings/15) ? Math.ceil(pasings/15) : page+5)}
            className={classes.naviArrow}
            size="24"
          />
          <AiOutlineDoubleRight 
            onClick={() => setPage(Math.ceil(pasings/15))}
            className={classes.naviArrow}
            size="24"
          />
        </div>
  
        <div className={classes.btnDiv}>
          <Button variant="outlined" onClick={() => checks.length > 0 && editSelItems()}>
            선택수정
          </Button>
        </div>
      </div>



      <Snackbar 
        open={errSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="error">수행을 실패 하였습니다!</Alert>
      </Snackbar>
      <Snackbar 
        open={succSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="success">수행을 성공 하였습니다!</Alert>
      </Snackbar> 
    </div>
  )
}

export default ItmeQtyConfig;
